import { e$2, n$2, u$1, i$1 } from '@/js/global/global'
import { srraf } from '@/js/modules/scroll-handlers'
import { switchImage } from '@/js/global/product-methods'

function stickyAtcBar (container) {
  const classes = {
    hidden: "hidden"
  };
  const selectors = {
    buyButtons: ".product-form__cart-submit",
    changeOptionButton: "[data-change-option-trigger]",
    imageWrap: ".product__media",
    optionValues: ".sticky-atc-bar__meta-options",
    pageFooter: "footer",
    stickyAtcBar: ".sticky-atc-bar",
    variantSelector: ".product__variants-wrapper",
    htmlEl: "html",
  };
  const elements = {
    buyButtons: n$2(selectors.buyButtons, container),
    pageFooter: n$2(selectors.pageFooter, document),
    stickyAtcBar: n$2(selectors.stickyAtcBar, container),
    variantSelector: n$2(selectors.variantSelector, container),
    htmlEl: n$2(selectors.htmlEl, document)
  };
  if (elements.stickyAtcBar == null) return;
  const isMobile = () => window.innerWidth < 960;
  elements.imageWrap = n$2(selectors.imageWrap, elements.stickyAtcBar);
  elements.optionValues = n$2(selectors.optionValues, elements.stickyAtcBar);
  elements.changeOptionButton = n$2(selectors.changeOptionButton, elements.stickyAtcBar);
  const events = [];
  if (elements.changeOptionButton) {
    events.push(e$2(elements.changeOptionButton, "click", () => scrollToVariantSelector()));
  }
  let widthWatcher;
  const buyButtonsObserver = new IntersectionObserver(_ref => {
    let [{
      isIntersecting: visible
    }] = _ref;
    // Check buy buttons top pos
    var buyButtonsTopPos = elements.buyButtons.getBoundingClientRect().top;
    // Only show sticky ATCB if the buy buttons are not visible AND above the scroll
    if (!visible && buyButtonsTopPos <= 0 ) {
      showBar();
    } else {
      hideBar();
    }
  });
  const footerObserver = new IntersectionObserver(_ref2 => {
    let [{
      isIntersecting: visible
    }] = _ref2;
    if (visible) {
      buyButtonsObserver.disconnect();
      hideBar();
    } else {
      buyButtonsObserver.observe(elements.buyButtons);
    }
  }, {
    threshold: 0.8
  });
  footerObserver.observe(elements.pageFooter);
  const setHeightVariable = () => {
    document.documentElement.style.setProperty("--sticky-atc-bar-height", "".concat(elements.stickyAtcBar.offsetHeight, "px"));
  };
  const clearHeightVariable = () => {
    document.documentElement.style.setProperty("--sticky-atc-bar-height", "0px");
  };
  const showBar = () => {
    var _widthWatcher0;
    (_widthWatcher0 = widthWatcher) === null || _widthWatcher0 === void 0 ? void 0 : _widthWatcher0.destroy();
    i$1(elements.stickyAtcBar, classes.hidden);
    // add an active Class to <html> to style other elements (like the scroll to top btn)
    elements.htmlEl.classList.add('sticky-atc-bar-active');

    setHeightVariable();
    widthWatcher = srraf(_ref3 => {
      let {
        pvw,
        vw
      } = _ref3;
      if (pvw !== vw) {
        setHeightVariable();
      }
    });
  };
  const hideBar = () => {
    if (isMobile()) return;
    var _widthWatcher;
    u$1(elements.stickyAtcBar, classes.hidden);

    // remove the active class from <html>
    if ( elements.htmlEl.classList.contains('sticky-atc-bar-active') ) {
      elements.htmlEl.classList.remove('sticky-atc-bar-active');
    }

    (_widthWatcher = widthWatcher) === null || _widthWatcher === void 0 ? void 0 : _widthWatcher.destroy();
    clearHeightVariable();
  };
  if (isMobile()) showBar();
  events.push(e$2(window, 'resize', () => { if (isMobile()) showBar(); }));
  const scrollToVariantSelector = () => {
    elements.variantSelector.scrollIntoView({
      block: "center",
      behavior: "smooth"
    });
  };
  const switchCurrentImage = id => {
    switchImage(elements.imageWrap, id);
  };
  const updateOptionValues = variant => {
    const optionValueString = variant.options.join(", ");
    elements.optionValues.textContent = optionValueString;
  };
  const unload = () => {
    var _widthWatcher2;
    buyButtonsObserver === null || buyButtonsObserver === void 0 ? void 0 : buyButtonsObserver.disconnect();
    events.forEach(unsubscribe => unsubscribe());
    footerObserver === null || footerObserver === void 0 ? void 0 : footerObserver.disconnect();
    (_widthWatcher2 = widthWatcher) === null || _widthWatcher2 === void 0 ? void 0 : _widthWatcher2.destroy();
  };
  return {
    switchCurrentImage,
    unload,
    updateOptionValues
  };
  }

export { stickyAtcBar }
